import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`max-width: ${_vm.size*1.25}px`)},[_c('div',{staticClass:"mask-skew",style:(`background: ${_vm.backgroundColor}; width: ${_vm.size*1.25}px; height: ${_vm.size - (_vm.size/6)}px`)},[_c('div',{staticClass:"art-skew"},[_c(VIcon,{attrs:{"color":_vm.iconColor,"size":_vm.size}},[_vm._v(_vm._s(_vm.icon))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }